<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose } from "vue";
import { useRouter } from 'vue-router'
import Loading from 'vue3-loading-overlay';
import MyPageResumeModalBody from "../mypage/MyPageResumeModalBody.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import jobFairCorpService from "../../../services/jobFair/jobFairCorpService";
import {useUserStore} from "@/pages/user/stores/user";
import JobFairJobNoticeListModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeListModal.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
const { $confirm, $alert } = useAlertStore();

const router = useRouter();
const loadingStore = usePageLoadingStore()

const baseModal = ref(null);
const resolvePromise = ref(null);

const modalBody = ref(null);
const modalContent = ref([]);
const jobNoticeListModal = ref([]); // 채용공고 목록 팝업

const loaded = ref(false);

const showButtons = ref(false); // 수정, 삭제 버튼 : 마이페이지/특별채용관/구직자 이력서 클릭 시 나오는 버튼
const showCorpButtons =ref(false); // 관심인재, 면접제안 버튼 : 마이페이지/특별채용관/기업 관심 인재에서 이력서 클릭 시 나오는 버튼
const resumeLikeTxts = ref("♡관심인재");
const disabledCorpYns = ref(false);
const interestYns = ref(0);
const resumeIds = ref(0);
const ojfIds = ref(0);
const commonDatas = ref(''); // 공통 데이터
const gnbResumes = ref('');
const joinStateGbs = ref(0); // 행사참가 상태 구분
const applicantCnts = ref(0); // 입사지원 이력
const intvProposalCnts = ref(0); // 받은 면접제안 수락/거절 시
const modes = ref('');

const { user } = useUserStore() // 사용자 정보


// 마이페이지 특별채용관 이력서 보기
// 구직자일 때, commonDeta는 resOpenYn 데이터를 받음 (이력서 삭제 여부)
// 기업일 때, commonData는 corpId 데이터를 받음 (면접 제안)
const retrieveJobFairRecordDetail = (resumeId, ojfId, commonData) => {
  resumeIds.value = resumeId;
  ojfIds.value = ojfId;
  commonDatas.value = commonData;
  loaded.value = false;

  if(resumeId) {
    let paramObj = {
      resumeId: resumeId,
      hidden: 0,
    }
    jobFairUserService.ojfResumeDetail(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(0);
            modalBody.value.setRecord(result);
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  }
}

// 이력서 수정 버튼. 새창으로 열기
const onClickChangeResume = (resumeId, ojfId) => {
  router.push({ name: 'MyPageJobFairResume', query : { resumeId: resumeId, ojfId: ojfId, mode: modes.value }})
}

// 이력서 삭제 여부
// 구직자일 때, commonDeta는 resOpenYn 데이터를 받음 (이력서 삭제 여부)
const onClickDelete = async (resumeId, commonData) => {
  const resOpenYn = commonData;
  let message, okButtonText, cancelButtonText;
  if (resOpenYn === "Y") {
    message = ["인재정보에 공개된 이력서 입니다.", "그래도 이력서를 삭제하시겠습니까?"];
    okButtonText = "삭제";
    cancelButtonText = "취소";
  } else {
    message = ["이력서를 삭제하시겠습니까?"];
    okButtonText = "삭제";
    cancelButtonText = "취소";
  }

  const ok = await $confirm(message, okButtonText, cancelButtonText);
  if(!ok) {
    return -1;
  } else {
    jobFairUserService.ojfResumeDelete ( resumeId )
        .then(async (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            if(resOpenYn === "Y") {
              $alert(["이력서가 삭제되었습니다.", "인재정보에 공개할 이력서를 다시 선택하세요."]);

              baseModal.value.close();
              resolvePromise.value(false);
            } else {
              $alert(["이력서 삭제되었습니다."]);
              baseModal.value.close();
              resolvePromise.value(false);
            }
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  }
}

// 관심인재
const onClickResumeLikeYn = async (resumeId, ojfId, interestYn) => {
  let message, okButtonText;
  if(interestYn === 'Y') {
    interestYn = 'N'
    message = ["관심인재를 삭제하시겠습니까?"];
    okButtonText = "관심인재 삭제";
  } else {
    interestYn = 'Y'
    message = ["관심인재를 등록하시겠습니까?"];
    okButtonText = "관심인재 등록";
  }
  const ok = await $confirm(message, okButtonText, "취소");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      interestYn: interestYn,
      ojfId: ojfId,
    }
    jobFairCorpService.ojfCropInterestEntryYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            modalContent.value = ["변경하였습니다."];
            $alert(["변경하였습니다."]);
            if(interestYn === 'N') {
              resumeLikeTxts.value = "♡관심인재";
              interestYns.value = 'N';
            } else {
              resumeLikeTxts.value = "♥관심인재";
              interestYns.value = 'Y';
            }
            //$toast('', msg+"을(를) 하였습니다.")
          } else {
            $alert(["변경을 실패하였습니다."]);
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          modalContent.value = ["변경을 실패하였습니다."];
          $alert(["변경을 실패하였습니다."]);
        });
  }
}

// 면접제안
// commonDatas = corpId (공통데이터는 여기서 회사Id)
const onClickResumeCorpYn = (ojfId, resumeId, mode) => {

  jobNoticeListModal.value.interviewProposalJobNoticeList(ojfId, resumeId, mode);
  jobNoticeListModal.value.show();
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (showButton, showCorpButton, interestYn, gnbResume, joinStateGb, applicantCnt, intvProposalCnt, mode) => {

  // 기본값 저장
  showButtons.value = showButton; // 수정, 삭제 버튼
  showCorpButtons.value = showCorpButton; // 관심인재, 면접제안 버튼

  // 관심인재
  if(interestYn === 'Y') {
    resumeLikeTxts.value = "♥관심인재";
  } else {
    resumeLikeTxts.value = "♡관심인재";
  }
  interestYns.value = interestYn;

  gnbResumes.value = gnbResume; // gnb 인재정보에서 이력서 볼 때 삭제 버튼 숨기기 위한 데이터
  joinStateGbs.value = joinStateGb; // 행사 상태 구분 (삭제 버튼 관리)
  applicantCnts.value = applicantCnt; // 입사지원 이력 0: 입사지원 X (삭제 버튼 관리)
  intvProposalCnts.value = intvProposalCnt; // 받은 면접제안 수락/거절 수 0이 아닐 경우 수정,삭제 버튼 노출 X
  modes.value = mode;
}

defineExpose({
  show,
  init,
  retrieveJobFairRecordDetail,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded">
        <MyPageResumeModalBody ref="modalBody"/>
      </div>
      <div v-if="showButtons" class="modal-footer">
        <div v-if="intvProposalCnts === undefined" style="width: 100%; padding: 0; text-align: right;">
          <div v-if="gnbResumes"><KSAPrimaryButton text="수정" @click="onClickChangeResume(resumeIds, ojfIds)" /></div>
        </div>
        <!-- 면접제안을 수락/거절했을 경우 수정 불가, 삭제 불가 -->
        <div v-if="intvProposalCnts === 0" style="width: 100%; padding: 0">
            <!-- 승인/반려 처리 이전(01 신청 접수 완료 02 신청 검토중) = 수정가능, 삭제 불가 -->
            <div v-if="joinStateGbs === '01' || joinStateGbs === '02'" style="width: 100%; padding: 0; text-align: right;">
                <KSAPrimaryButton text="수정" @click="onClickChangeResume(resumeIds, ojfIds)" />
            </div>
            <!-- 승인처리 이후(11) -->
            <div v-else-if="joinStateGbs === '11'" style="width: 100%; padding: 0">
                <!-- 승인처리 이후 + 입사지원 없는 경우 = 수정가능, 삭제 가능 -->
                <div v-if="applicantCnts === 0" class="modal-footer btn-wrap" style="width: 100%; padding: 0">
                    <KSASecondaryButton text="삭제" v-show="!gnbResumes" class="red_button" @click="onClickDelete(resumeIds, commonDatas)" />
                    <KSAPrimaryButton text="수정" @click="onClickChangeResume(resumeIds, ojfIds)" />
                </div>
            </div>
            <!-- 반려 처리 이후 = 수정가능(의미없음), 삭제 가능 -->
            <div v-else-if="joinStateGbs === '21'" class="modal-footer btn-wrap" style="width: 100%; padding: 0">
                <KSASecondaryButton text="삭제" v-show="!gnbResumes" class="red_button" @click="onClickDelete(resumeIds, commonDatas)" />
                <KSAPrimaryButton text="수정" @click="onClickChangeResume(resumeIds, ojfIds)" />
            </div>
        </div>
      </div>
      <div v-if="showCorpButtons" class="modal-footer btn-wrap">
        <span data-title="관심인재 : ">
          <KSASecondaryButton :text="resumeLikeTxts" @click="onClickResumeLikeYn(resumeIds, ojfIds, interestYns)" class="red_button"/>
        </span>
        <span data-title="면접제안 : ">
          <KSAPrimaryButton text="면접제안" :disabled="disabledCorpYns" @click="onClickResumeCorpYn(ojfIds, resumeIds, modes)" />
        </span>
      </div>
    </div>
  </Modal>
  <JobFairJobNoticeListModal ref="jobNoticeListModal" />
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>